import React from 'react';
import { iconSize } from './constants.mjs';

const withoutBoundingBoxWidth = {
  large: 34,
  medium: 25,
  small: 18,
  xSmall: 14
};
const CartEmptyBoldIcon = ({ size = "medium", withBoundingBox = true, ...others }) => {
  let iconWidth, iconHeight;
  if (typeof size === "string") {
    iconWidth = withBoundingBox ? iconSize[size] : withoutBoundingBoxWidth[size];
    iconHeight = iconSize[size];
  } else {
    iconWidth = size;
    iconHeight = size;
  }
  return /* @__PURE__ */ React.createElement(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: iconWidth,
      height: iconHeight,
      viewBox: "0 0 30 30",
      preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
      fill: "none",
      ...others
    },
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.97466 5.54004H1.98047V7.04004H5.78643L9.02636 20.82H23.4319L26.8794 7.42443L7.44332 7.53689L6.97466 5.54004ZM10.2135 19.319L7.79563 9.03324L24.9405 8.9349L22.2687 19.319H10.2135Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M10.1605 21.61C9.40936 21.61 8.80047 22.2189 8.80047 22.97C8.80047 23.7212 9.40936 24.33 10.1605 24.33C10.9116 24.33 11.5205 23.7212 11.5205 22.97C11.5205 22.2189 10.9116 21.61 10.1605 21.61Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M22.6805 21.61C21.9294 21.61 21.3205 22.2189 21.3205 22.97C21.3205 23.7212 21.9294 24.33 22.6805 24.33C23.4316 24.33 24.0405 23.7212 24.0405 22.97C24.0405 22.2189 23.4316 21.61 22.6805 21.61Z",
        fill: "currentColor"
      }
    )
  );
};
CartEmptyBoldIcon.iconName = "CartEmptyBoldIcon";

export { CartEmptyBoldIcon };
